var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 24.0001V16.5001H16.9999V24.0001C16.9999 24.8251 17.6749 25.5001 18.4999 25.5001H22.9999C23.8249 25.5001 24.4999 24.8251 24.4999 24.0001V13.5001H27.0499C27.7399 13.5001 28.0699 12.6451 27.5449 12.1951L15.0049 0.900078C14.4349 0.390078 13.5649 0.390078 12.9949 0.900078L0.454903 12.1951C-0.055097 12.6451 0.259903 13.5001 0.949903 13.5001H3.4999V24.0001C3.4999 24.8251 4.1749 25.5001 4.9999 25.5001H9.4999C10.3249 25.5001 10.9999 24.8251 10.9999 24.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.f37def9af82ec53496f48b0215cd431c.svg";
export { ForwardRef as ReactComponent };